var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakao({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.04889C4.76667 1.04889 0 5.25556 0 8.81445C0 11.4811 1.73111 13.8333 4.36778 15.2311L3.25889 19.3044C3.16 19.6656 3.57 19.9522 3.88444 19.7444L8.74778 16.5167C9.15778 16.5567 9.57556 16.58 10 16.58C15.5222 16.58 20 13.1033 20 8.81445C20 5.25556 15.5222 1.04889 10 1.04889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.451bcc30a8180642dfe9740f5c1f00b0.svg";
export { ForwardRef as ReactComponent };